// extracted by mini-css-extract-plugin
module.exports = {"container":"_3zTBK","suggestions":"_2LDr-","appearing":"_2-7Jm","shownSuggestions":"_2YzET","suggestion":"NYih8","highlighted":"_2TMVW","groupTitle":"_2WJxW"};